<script setup lang="ts">
import {STAFF_STATUS_OPTIONS} from "@helpers/ConstantHelper.js";
</script>
<template>
  <AppChipSelect v-bind="$attrs" :items="STAFF_STATUS_OPTIONS"/>
</template>

